/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit InstallmentLength/view.blocks to change it.
import * as fromData from 'Simple/Data'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function InstallmentLength({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentPlans/Steps/Content/PaymentPlans/Content/Content/PaymentPlan/Content/Content/Send/Content/Sidebar/Content/Overview/PlanRules/InstallmentLength"
  
}) {
let rulesetCustomPaymentPlanRulesetMaxLengthValueData = fromData.useDataValue({ viewPath,
context: 'ruleset',
path: 'custom_payment_plan_ruleset.max_length',
})
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 weight="semibold"
 data="ruleset.custom_payment_plan_ruleset.max_length"
 text={rulesetCustomPaymentPlanRulesetMaxLengthValueData}
/>
{children}
</React.Fragment>)
}